import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";
import { prepareSearchParams } from "@/libs/helper";

const resource = `${Config.basePath}/report/performance`;

export default {
  index(payload) {
    return Client.get(`${resource}`, {
      params: prepareSearchParams(payload),
    });
  },
  exportExcel(payload) {
    return Client.get(`${resource}/export`, {
      params: payload,
      responseType: "blob",
    });
  },
};
